import taxTableCapitalArray from "../../datasets/tax_table_capital_array";
import TaxTableArray from "../../datasets/tax_table_dataset"

export const calcTaxAmt = (assetTable, taxType, returnType) => {
  
   var sortTaxTableArr = [];
   var taxTableArray = TaxTableArray;
   let monthlySalaryAmt = 0;
   let returnValue = 0;
   if (!taxType){
      taxType = "regular";
   }
   if (!returnType){
      returnType = "TaxAmt";
   }
   for (let i=0; i<assetTable.length; i++){
       if (+assetTable[i].assetNbrMonths !== 0){
            monthlySalaryAmt += +assetTable[i].assetAmt; 
       }
   }
   const annualSalary = (monthlySalaryAmt * 12).toFixed(2);
   let annualSalaryNbr = +annualSalary;
   if (taxType === "capital"){
      sortTaxTableArr = taxTableCapitalArray.sort(
         (taxA, taxB) => taxB.salary - taxA.salary);    
   }else{
      sortTaxTableArr = taxTableArray.sort(
          (taxA, taxB) => taxB.salary - taxA.salary);  
   }

   for (let i=0; i < sortTaxTableArr.length; i++)
   {
      if (annualSalaryNbr >= sortTaxTableArr[i].salary)
      {
         if (returnType === "TaxRate"){
            const taxRate = +sortTaxTableArr[i].taxRate;
            returnValue = taxRate;
         }else{
            const totalTaxAmt =((+sortTaxTableArr[i].federal + +sortTaxTableArr[i].fica) / 12).toFixed(2);
            returnValue = totalTaxAmt;
         }
         break;
      }   
   }      
            
   return returnValue;
                 
}





